<script lang="ts" setup>
import NotificationsContainer from '@/components/notification/NotificationsContainer.vue';


import TheHeaderBar from '@/components/TheHeaderBar.vue';

</script>

<template>
  <div class="z-1 bg-shade-light w-full h-full flex flex-col rounded-b overflow-hidden">
    <TheHeaderBar />
    <NotificationsContainer class="flex-grow overflow-y-auto">
      <router-view />
    </NotificationsContainer>
  </div>
</template>